export const uberallWidgetTitle = 'Uberall Storefinder'
export const uberallDataKeyDefault = 'iGV2TGWsODkoq1D1NyJqp58Zw0Hrs9'
